module.exports = __webpack_public_path__ + "static/img/event19.3d62f3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event19.png
// module id = RONc
// module chunks = 1